import { useAsync } from "@/shared/hooks/HookBase";
import { useCallback } from "react";
import type IAutomationService from "../contracts/IAutomationService";
import AutomationService from "../services/AutomationService";
import type AutomationSummary from "../models/AutomationSummary";
import type WorkflowDefinition from "../models/WorkflowDefinition";
import type { CreateWorkflowRequest, WorkflowVersionInfo } from "../models/WorkflowDefinition";
import { clearLayout } from "../lib/layoutStorage";

const automationService: IAutomationService = new AutomationService();

export function useAutomations() {
  const { loading, error, execute } = useAsync();

  const getAll = useCallback(async (): Promise<AutomationSummary[] | void> => {
    return await execute(() => automationService.GetAll());
  }, [execute]);

  const getWorkflow = useCallback(
    async (workflowId: string): Promise<WorkflowDefinition | null | void> => {
      return await execute(() => automationService.GetWorkflow(workflowId));
    },
    [execute],
  );

  const publish = useCallback(
    async (request: CreateWorkflowRequest): Promise<WorkflowVersionInfo | void> => {
      return await execute(() => automationService.Publish(request), {
        successMessage: "Automatización guardada correctamente",
      });
    },
    [execute],
  );

  const remove = useCallback(
    async (workflowId: string): Promise<void> => {
      await execute(() => automationService.Delete(workflowId), {
        successMessage: "Automatización eliminada correctamente",
      });
      clearLayout(workflowId);
    },
    [execute],
  );

  return { loading, error, getAll, getWorkflow, publish, remove };
}
